export const itemCss = {
  width: "100%",
  height: "100%",
};
